import React, { FunctionComponent } from 'react';

import { $FormGroupContainer } from './FormGroup.styles';

interface FormGroupProps {
  withoutPaddingBottom?: boolean;
  withoutPaddingTop?: boolean;
  isOpen?: boolean;
  dataTestId?: string;
  id?: string;
  isFluid?: boolean;
  className?: string;
}

const FormGroup: FunctionComponent<React.PropsWithChildren<FormGroupProps>> = ({
  withoutPaddingBottom = false,
  withoutPaddingTop = false,
  isOpen = true,
  dataTestId = 'FormGroupContainer',
  children,
  id,
  isFluid = true,
  className,
}) => {
  return (
    <$FormGroupContainer
      id={id}
      $withoutPaddingBottom={withoutPaddingBottom}
      $withoutPaddingTop={withoutPaddingTop}
      $isOpen={isOpen}
      data-testid={dataTestId}
      $isFluid={isFluid}
      className={className}
    >
      {children}
    </$FormGroupContainer>
  );
};

export default FormGroup;
